import * as React from 'react';

function SvgIconInputWebsite(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 16c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z" />
      <path d="M8.211 16C5.82 16 4 12.476 4 8s1.819-8 4.211-8c2.393 0 4.212 3.524 4.212 8 0 4.453-1.842 8-4.212 8zm0-15.034C6.487.966 4.983 4.17 4.983 8c0 3.83 1.504 7.034 3.228 7.034 1.725 0 3.23-3.205 3.23-7.034 0-3.805-1.527-7.034-3.23-7.034z" />
      <path d="M2.24 3.45a.494.494 0 01-.175-.666c.135-.237.41-.324.63-.186a10.665 10.665 0 005.29 1.412c1.878 0 3.693-.493 5.316-1.442.223-.141.499-.054.635.183a.495.495 0 01-.178.667A11.325 11.325 0 017.984 5C6 5 4.01 4.463 2.24 3.45zm.238 10.05a.477.477 0 01-.412-.245.516.516 0 01.183-.691C4.031 11.546 6.025 11 8 11c2.006 0 3.997.527 5.757 1.533.23.147.315.445.178.688-.138.244-.419.334-.642.192A10.451 10.451 0 008 11.989c-1.83 0-3.682.499-5.266 1.359-.057.122-.127.152-.256.152zm13.039-5.017H.483C.2 8.483 0 8.28 0 7.992S.2 7.5.483 7.5h15.034c.283 0 .483.204.483.492a.488.488 0 01-.483.491z" />
    </svg>
  );
}

export default SvgIconInputWebsite;
